<template>
  <div>
    <AtomSpinnerCentred v-if="loading" />
    <Chart
      v-if="!loading"
      :date-range="dateRange"
      :width="graphWidth"
      :data-sets="dataSet"
    />
  </div>
</template>

<script>
import Chart from "@/components/general-components/chart/Chart";
import AtomSpinnerCentred from "@/components/general-components/loading/AtomSpinnerCentred";
import { graphMixin } from "@/modules/dashboard/utilities/graphMixin";

export default {
  mixins: [graphMixin],

  name: "GraphTile",
  components: { Chart, AtomSpinnerCentred },
  props: {
    dataSet: {
      type: Array,
      default() {
        return [];
      }
    },
    dateRange: {
      type: Array,
      default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {};
  }
};
</script>

<style scoped></style>
